import React from 'react';
import * as Sentry from '@sentry/browser';

import { useTranslation } from 'react-i18next';
import { Modal, Button, ToastContext } from '@weezevent/nacre';

import useAppContext from '../../../context/useAppContext';
import { useNotifications, triggerToast } from '../../../components/notifications/notificationsProvider';

export default function ModerationPostAction({ actionInstance, onClose, sync }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const { addNotification } = useNotifications();

    const [{ event, organization }] = useAppContext();
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const _filtered_attendees = React.useMemo(() => {
        return actionInstance.filtered_items;
    }, [actionInstance]);

    const _onClose = React.useCallback(() => {
        onClose();
        setIsSubmitting(false);
    }, [onClose]);

    const handleSubmit = React.useCallback(
        (willNotify = false) => {
            setIsSubmitting(true);
            actionInstance
                .runPostAction({ attendees: _filtered_attendees, notifyAttendees: willNotify, moderationStatus: actionInstance.NAME })
                .then(response => {
                    triggerToast('attendees', actionInstance, actionInstance.filtered_items.length, response, t, toast, addNotification, 'ticket.manager.common.moderation.toast.');
                    _onClose();
                })
                .catch(e => {
                    console.error(e);
                    Sentry.captureException(e);
                    toast.error(t('ticket.manager.common.moderation.toast.error', { count: _filtered_attendees.length }));
                    setIsSubmitting(false);
                });
        },
        [actionInstance, setIsSubmitting, sync, _onClose, event, organization, toast, addNotification]
    );

    React.useEffect(() => {
        if (Array.isArray(_filtered_attendees) && !_filtered_attendees.length) {
            _onClose();
        }
    }, [actionInstance, _filtered_attendees]);
    return (
        <Modal
            open={Boolean(actionInstance && Array.isArray(_filtered_attendees) && _filtered_attendees.length)}
            onClose={_onClose}
            title={t('ticket.manager.common.moderation.informAttendee', { count: actionInstance.filtered_items.length })}
            submitButton={
                <Button
                    primary
                    onClick={() => {
                        handleSubmit(true);
                    }}
                    disabled={isSubmitting}
                    isLoading={isSubmitting}
                    label={t('ticket.common.action.send')}
                />
            }
            cancelButton={
                <Button
                    onClick={() => {
                        handleSubmit(false);
                    }}
                    disabled={isSubmitting}
                    isLoading={isSubmitting}
                    label={t(`ticket.common.cta.doNotSend`)}
                />
            }
        >
            <div>{t('ticket.manager.common.moderation.informAttendeeText', { count: actionInstance.filtered_items.length })}</div>
        </Modal>
    );
}
